import { useState, useRef, useEffect } from 'react';

//reducers
import { useStore } from 'react-redux';
import { error as toastError } from 'hyc-store/reducers/toast';
import { UseToast, ShowSuccessToast } from 'shared/functions';


// components
import { Button } from 'shared/components/bulma/button';
import { ProductRow } from "shared/components/product-row/product-row";

// helper
import * as helper from './helper';

const Returns = () => {
    const [barcode, setBarcode] = useState('');
    const [product, setProduct] = useState(null);

    const [loading, setLoading] = useState(false);
    const store = useStore();
    const inputElement = useRef(null);

    const handleClick = async () => {
        setLoading(true);

        try {
            await helper.handleReturn(barcode);
            ShowSuccessToast('Success!');
            reset();

        } catch (error) {
            store.dispatch(toastError(error.message));
        }
        reset();
        setLoading(false);
    }

    const handleChange = (event) => {
        const { value } = event.target;
        setBarcode(value);
    }

    const handleDelete = async () => {
        if (!window.confirm('Are you sure?')) {
            return;
        };
        reset();
    };

    const reset = () => {
        setProduct(null);
        setBarcode('');
        inputElement.current.focus();
    }

    const handleEnter = async (event) => {
        try {
            if (event.charCode === 13) {
                // enter pressed
                if (!!product) {
                    // enabling clicking enter to trigger the Return button
                    handleClick();
                } else {
                    let product = await helper.getProduct(barcode);
                    setProduct(product);
                    if (product && product.length > 0) {
                        throw new Error('No product with this barcode')
                    }
                }
            }
        } catch (error) {
            console.error(error)
            store.dispatch(toastError(error.message));
            reset();
        }
    }

    useEffect(() => {
        if (inputElement.current) {
            inputElement.current.focus();
        }
        UseToast();
    }, []);

    return (
        <div className="container">

            <nav className="level">
                <div className="level-right">

                    <div className="level-item">
                        <div>
                            <h1 className="title">Returns</h1>
                            <h2 className="heading is-2">From here, you would be able to return all the products!</h2>
                        </div>
                    </div>

                </div>
            </nav>
            <div className="columns">
                <div className="column is-4 is-offset-4">
                    <div className="field">
                        <div className="control">
                            <input className="input is-medium"
                                ref={inputElement}
                                onChange={handleChange}
                                autoFocus
                                type="text" placeholder="Barcode"
                                id="barcode"
                                name="barcode"
                                value={barcode}
                                onKeyPress={handleEnter} />
                        </div>
                    </div>

                    {!!product && <ProductRow key={product.barcode} product={product} onRemove={handleDelete} />}

                    {!!product && product.flagged &&
                        <article className="message is-primary p-6 mt-3">
                            <div className="message-body">
                                Please put this garment aside and give it to Distribution before washing.
                            </div>
                        </article>
                    }

                </div>
                <div className="column is-2">

                    <Button className={`is-info ${loading ? 'is-loading' : ''}`} name="returns" disabled={!product} onClick={handleClick}>
                        RETURN
                    </Button>

                </div>
            </div >
        </div>

    );
};

export { Returns };
